import { alphaSort } from 'vet-bones/utils';

import {
  MappingField,
  ModelConceptAttributeData,
} from 'src/containers/ProjectDiagram/types/data';
import { getLabelForIri } from 'src/containers/ProjectDiagram/utils/labels';
import { getBindingAndVariableFunction } from 'src/utils/stringify/mappings/bindings';

export const mappingFieldSort = alphaSort((item: MappingField) => item.value);
export const attributeDataSort = alphaSort(
  (item: ModelConceptAttributeData) => item.value
);

export const stringifyLabel = (text: string) => text.replace(/\W/g, '_');

export const getMappingHelpers = ({
  aliasesByColumnName,
  dataNamespace,
  labelsByIri,
}: {
  aliasesByColumnName?: Record<string, string> | null;
  dataNamespace: string;
  labelsByIri: Record<string, string>;
}) => {
  const getStringifiedLabel = (iri: string) =>
    stringifyLabel(getLabelForIri(labelsByIri, iri));

  const usedVariables: Record<string, number> = {};
  const getUniqueVariable = (variable: string) => {
    if (usedVariables[variable] === undefined) {
      usedVariables[variable] = 0;
      return variable;
    }

    usedVariables[variable] += 1;
    return `${variable}_${usedVariables[variable]}`;
  };

  const getBindingAndVariable = getBindingAndVariableFunction({
    aliasesByColumnName,
    dataNamespace,
    getStringifiedLabel,
    getUniqueVariable,
  });

  return {
    getBindingAndVariable,
    getStringifiedLabel,
    getUniqueVariable,
  };
};
